module.exports = __webpack_public_path__ + "img/dark-profile.c1a10a25.svg";